<template>
  <div class="main">
    <div class="list-box" v-if="list.length">
      <van-pull-refresh v-model="refreshing" @refresh="getList">
        <div class="list-item" v-for="item in list" :key="item.id">
          <div class="list-item-left">
            <div class="left-top">充值：{{item.payAmount}}元</div>
            <div class="left-bottom">时间：{{item.createDate}}</div>
          </div>
          <div class="list-item-right">{{item.status | statusEnum}}</div>
        </div>
      </van-pull-refresh>
    </div>
    <div class="no-data"  v-else>
      <van-image  width="170px" height="auto" fit="fill" :src="noDataImg" />
      <div>暂无数据</div>
    </div>
  </div>
</template>

<script>
import loadingMixin from '@/mixins/loading-mixin'
import noDataImg from '@/assets/images/img-default@2x.png'
export default {
  name: 'RechargeRecords',
  mixins: [loadingMixin],
  data() {
    return {
      refreshing: false,
      noDataImg,
      list: []
    };
  },
  methods: {
    getList() {
      if (!this.$route.query.activityId) {
        return;
      }
      const params = {
        pageNum: 1,
        pageSize: 200,
        filterData: {
          ...this.$route.query
        }
      };
      this.showLoading();
      this.$api.activityMgmt.getRedPacketRechargeRecords(params)
        .then(({data: {list}}) => {
          this.list = list || [];
        })
        .finally(_ => {
          this.refreshing = false;
          this.hideLoading();
        });
    }
  },
  filters: {
    statusEnum(val) {
      const map = {
        '-1': '已取消',
        0: '未支付',
        1: '支付中',
        2: '支付成功',
        3: '支付失败',
      };
      return map[val]
    }
  },
  created() {
    this.getList();
  }
}
</script>

<style lang="stylus" scoped>
.main
  height 100vh
  overflow-y auto
  &::-webkit-scrollbar
    display: none
  .list-box
    .list-item
      margin 15px
      padding 10px
      display: flex
      justify-content: space-between
      align-items: center
      background-color: #fff
      border-radius: 6px
      .list-item-left{
        line-height: 22px;
        .left-bottom {
          color: #999999;
          font-size: 13px;
        }
      }
    >>> .van-pull-refresh
      min-height: 50vh
  .empty-box
    height 100%
  .no-data
    text-align center
    color #BBBBBB
    font-size 14px
    line-height 2
    padding-top 80px
    height calc(100vh - 50px - 245px - 50px - 80px)
</style>